import { call } from "./calls";

export const Branch = {
    create: (values) => call("/Branch","POST", values)
}